import React from "react";
import classNames from "classnames";
import { AppButton } from "@/shared/Components";
import { CloseCardButton } from "@/shared/icons";
import styles from "./styles.module.scss";

interface Props {
  closeCard: () => void;
}

export const ButtonCardClose: React.FC<Props> = ({ closeCard }) => {
  return (
    <AppButton
      type="text"
      onClick={closeCard}
      className={classNames(styles.close)}
      icon={<CloseCardButton />}
    />
  );
};
